<template>
  <div class="certificate-profile">
    <Header></Header>
    <sub-header :title="'صفحة الشهادة'"></sub-header>
    <div class="certificate-info">
      <b-container>
        <div class="tab-container mb-4">
          <b-row class="justify-content-center align-items-center">
            <b-col lg="5" cols="12">
              <div class="certificate-picture">
                <img
                  v-if="certificateData.file"
                  :src="certificateData.file.url"
                  alt=""
                />
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="tab-container mb-4">
          <b-row>
            <b-col md="8" cols="12">
              <CertificateDescription
                :certificateData="certificateData"
              ></CertificateDescription>
            </b-col>
          </b-row>
        </div>

        <div class="tab-container mb-4">
          <b-row>
            <div class="certificate-contact">
              <b-row>
                <b-col class="certificate-media" md="12" cols="12">
                  <div>اهداف الشهادة</div>
                  <p class="certificate-description">
                    تأهيلك للعمل في مجال صيانة المعدات الطبية، واكتساب خبرة
                    عملية في هذا المجال، والحصول على شهادات معتمدة تعزز من فرصك
                    المهنية.
                  </p>
                </b-col>
                <b-col class="certificate-media" md="12" cols="12">
                  <div>محتوى الشهادة</div>
                  <p class="certificate-description">
                    مبادئ صيانة المعدات الطبية، أدوات وتقنيات الصيانة، إدارة
                    الأعطال وإصلاحها، إجراءات السلامة والصحة المهنية، تدريبات
                    عملية على صيانة المعدات الطبية.
                  </p>
                </b-col>
              </b-row>
            </div>
          </b-row>
        </div>



        <div class="tab-container mb-4">
          <b-row>
            <ContactUs/>
          </b-row>
        </div>


        
      </b-container>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import CertificateDescription from "@/components/Certificate/CertificateDescription.vue";
import Header from "@/components/Certificate/Header.vue";
import Footer from "@/components/Home/Footer.vue";
import axios from "axios";
import SubHeader from "@/components/Certificate/SubHeader.vue";
import ContactUs from '@/components/common/ContactUs.vue'
 
export default {
  name: "certificateShow",
  components: { Header, Footer, CertificateDescription, SubHeader,ContactUs },
  data() {
    return {
      tabIndex: 0,
      certificateData: {},
      searchQuery: null,
    };
  },
  async created() {
    // Fetch data from APIs
    await this.fetchcertificateData();
  },

  watch: {
    searchQuery: {
      immediate: true,
    },
  },

  methods: {
    async fetchcertificateData() {
      try {
        const response = await axios.get(
          `/certificates/${this.$route.params.id}`
        );
        this.certificateData = response.data.data.certificate;
      } catch (error) {
        console.error("Error fetching certificate data:", error);
      }
    },
  },
};
</script>
<style lang=""></style>
